import { Box, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { GenericInputAction } from '../../../UI/GenericInputAction/GenericInputAction'
import { usePutAway } from '../../Context/usePutAway'
import { HeaderPutAway } from '../HeaderPutAway/HeaderPutAway'
import { SkuListPutAway } from '../SkuListPutAway/SkuListPutAway'
import { putAwayActions } from '../../actions/putAwayActions'
import { putAwayActions as putAwayBusiness } from '../../actions/putAwayBusiness'

import { ClearAdornment } from '../../../UI/Adornments/ClearAdornment'
import { NextAdornment } from '../../../UI/Adornments/NextAdornment'
import { SwitchViewPutAway } from '../SwitchViewPutAway/SwitchViewPutAway'
import { SKUInput } from './SKUInput'
import { NotificationPutAway } from '../NotificationPutAway/NotificationPutAway'
import { Loading } from '../../../UI'
import { useConfiguration } from '../../../../hooks/useConfiguration'
import { LpnState, eTypePosition } from '../../types/enums'
import { useSnackbar } from '../../../../hooks/useSnackbar'
import { SnackBar } from '../../../SnackBar/Snackbar'
import { stepperTypes } from '../../types/stepperTypes'

import { Modal } from '../../../../components/_EOS/Modal'
import { useModal } from '../../../../hooks/useModal'
import { FefoModal } from './FefoModal/FefoModal'
interface LocateSKUPutAwayProps {}

export const LocateSKUPutAway: React.FC<LocateSKUPutAwayProps> = () => {
  const {
    isActive: isActiveSnackbar,
    message: messageSnackbar,
    isSuccess: isSuccessSnackbar,
    openSnackBar
  } = useSnackbar()

  const [styleModeQuality, setStyleModeQuality] = useState<boolean>(false)
  const { state } = usePutAway()
  const [unitaryPutaway, setUnitaryPutaway] = useState<boolean>(false)
  const {
    size,
    isOpen,
    title,
    openModal: openModalDialog,
    closeModal: closeModalDialog
  } = useModal('Estás moviendo a posición de calidad.')
  const {
    inputQty,
    ubication,
    skuEan,
    SkuListOnPosition,
    isShowNotification,
    isShowExcess,
    error,
    item,
    workOrderInboundLocate,
    typePositionId,
    showFefoModal,
    selectedBatchId
  } = state
  const {
    handleChangeGenericInput,
    handleResetGenericInput,
    validatePosition,
    addElementToSKUList,
    validateStepBack,
    setShowBatchCompletedModal
  } = putAwayActions()

  const { findWorkingLpn } = putAwayBusiness()
  const { configurationState, getConfiguration } = useConfiguration()

  useEffect(() => {
    if (configurationState === undefined) {
      getConfiguration()
    } else {
      const unitaryPutawayConfiguration =
        configurationState.configuration.filter(
          (el) => el.name === 'UnitaryPutaway'
        )[0]

      if (unitaryPutawayConfiguration !== undefined) {
        setUnitaryPutaway(unitaryPutawayConfiguration.value === 'true')
      }
    }
  }, [configurationState])

  const NextAdornmentComponent = (
    <NextAdornment onClick={() => handleResetGenericInput('setInputQty')} />
  )

  useEffect(() => {
    if (typePositionId !== 0) {
      if (typePositionId === eTypePosition.CLDREC) {
        setStyleModeQuality(true)
        openModalDialog()
      } else {
        setModePromise().then(() => {
          document.getElementById('skuEan')?.focus()
        })

        setStyleModeQuality(false)
      }
    }
  }, [typePositionId])

  useEffect(() => {
    setStyleModeQuality(false) // por defecto deja estilo normal
  }, [])

  useEffect(() => {
    if (ubication.status === 'default') {
      setStyleModeQuality(false)
    }
  }, [ubication])

  const adornment = (
    <ClearAdornment
      onClick={() => handleResetGenericInput('setUbication')}
      disabled={SkuListOnPosition.length > 0}
    />
  )

  const onInputQuantityEnterPress = (
    e: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (!inputQty.value) {
      return
    }

    addElementToSKUList(e, selectedBatchId)
  }

  useEffect(() => {
    if (
      item?.lpn.length === 1 &&
      findWorkingLpn()?.lpnStateId === LpnState.Finished
    ) {
      openSnackBar(`LPN ${item?.workingLpn} finalizada exitosamente`, true)

      // muestra el mensaje que lpn se finalizo y devuelve a la pantalla de selección de lpn
      setTimeout(() => {
        validateStepBack(
          stepperTypes.stepDescriptionPutAway,
          workOrderInboundLocate
        )
      }, 3000)
    }
  }, [item])

  useEffect(() => {
    if (state.showBatchCompletedModal) {
      const timer = setTimeout(() => {
        setShowBatchCompletedModal(false)
      }, 3000)

      return () => clearTimeout(timer)
    }
    return undefined
  }, [state.showBatchCompletedModal])

  const handleCancelModalQuality = () => {
    closeDialogPromise().then(() => {
      setStyleModeQuality(false)
      document.getElementById('ubication')?.focus()
    })
  }

  const handleAceptModalQuality = () => {
    closeDialogPromise().then(() => {
      setStyleModeQuality(true)
      document.getElementById('skuEan')?.focus()
    })
  }

  const closeDialogPromise = (): Promise<string> => {
    return new Promise((resolve) => {
      closeModalDialog()
      resolve('')
      return true
    })
  }

  // se crea promesa para poder dar el focus al control ya cuando termine de asignar.
  const setModePromise = (): Promise<string> => {
    return new Promise((resolve) => {
      setStyleModeQuality(false)
      resolve('')
      return true
    })
  }

  const getPlaceholderText = () => {
    let text = 'Escanea la ubicación'
    if (item?.isReserveReception) text += ' (RESERVA)'
    if (item?.isPreSaleReception) text += ' (VENTA EN VERDE)'
    return text
  }

  if (!isShowNotification && !isShowExcess) {
    return state.loading ? (
      <div style={{ marginTop: '100px', marginRight: '20px' }}>
        <Loading />
      </div>
    ) : (
      <Fragment>
        <HeaderPutAway />
        <Box
          component='div'
          display='flex'
          flexDirection='column'
          flexWrap='nowrap'
          alignItems='left'
          padding='10px 10px 0px 7px'
        >
          <form
            onSubmit={(e) =>
              validatePosition(
                e,
                ubication.value,
                item?.isReserveReception || false,
                item?.isPreSaleReception || false
              )
            }
          >
            <GenericInputAction
              name='ubication'
              id='ubication'
              onChange={(e) => handleChangeGenericInput(e, 'setUbication')}
              placeholder={
                getPlaceholderText()
              }
              value={ubication.value}
              adornment={adornment}
              status={ubication.status}
              error={ubication.error.length > 0}
              errorText={ubication.error}
              backgroundColor={styleModeQuality ? '#ffd39e' : undefined}
            />
          </form>

          <SKUInput />

          <Modal
            open={showFefoModal}
            title={state.skuFefoType.modalTitle}
            maxWidth={'xs'}
          >
            <FefoModal asnId={item?.asnId || 0} lpn={item?.workingLpn} />
          </Modal>

          <Modal
            open={state.showBatchCompletedModal}
            title='Lote Completado'
            maxWidth={'sm'}
            onClose={() => setShowBatchCompletedModal(false)}
          >
            <Typography variant='body1' style={{ marginBottom: '16px' }}>
              ¡Has completado el total de unidades pactadas para este lote!
            </Typography>
            <Typography
              variant='body2'
              style={{ fontWeight: 'bold', color: '#2196f3' }}
            >
              {state.completedBatchInfo?.batchInfo}
            </Typography>
            <Typography
              variant='body2'
              style={{ marginTop: '16px', color: '#666' }}
            >
              Puedes continuar ubicando productos para otros lotes
            </Typography>
          </Modal>

          {!unitaryPutaway && (
            <GenericInputAction
              type='number'
              name='inputQty'
              id='inputQty'
              placeholder='Ingresa cantidad'
              onChange={(e) => handleChangeGenericInput(e, 'setInputQty')}
              value={inputQty.value}
              adornment={NextAdornmentComponent}
              status={inputQty.status}
              error={inputQty.error.length > 0}
              errorText={inputQty.error}
              disabled={skuEan.status !== 'success'}
              onKeyPress={onInputQuantityEnterPress}
            />
          )}
        </Box>

        <SwitchViewPutAway />

        <SkuListPutAway styleModeQuality={styleModeQuality} />

        <Box padding={10} color={'#ff3939'}>
          {error && <p>{error.error}</p>}
        </Box>
        <SnackBar
          message={messageSnackbar}
          status={isSuccessSnackbar ? 'success' : 'error'}
          open={isActiveSnackbar}
        />
        <Modal
          open={isOpen}
          title={title}
          onClose={closeModalDialog}
          maxWidth={size}
          cancelButton={{
            action: handleCancelModalQuality,
            title: 'Cancelar'
          }}
          successButton={{
            action: handleAceptModalQuality,
            title: 'Aceptar' // ,
            // disabled: validSaveButtonModelLpn()
          }}
        >
          <Typography variant='body1' style={{ color: 'red' }}>
            Has ingresado una ubicación de calidad, ¿Deseas ingresar productos
            en esta ubicación?
          </Typography>
        </Modal>
      </Fragment>
    )
  } else {
    return <NotificationPutAway />
  }
}
